import $ from 'jquery';
import 'slick-carousel';

export const init = () => {

	const $introCarousel = $('.b-intro.is-carousel');

	$introCarousel.find('.is-carousel__list').slick({
		dots: true,
		autoplay: true,
		infinite: true,
		autoplaySpeed: 3000,
	});

};



// WEBPACK FOOTER //
// ./src/js/components/carousel.js